import {Component, OnInit} from '@angular/core';
import {MessagingService} from './services/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private messagingService: MessagingService) {
  }

  ngOnInit(): void {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();

    window.addEventListener('resize', this.resetHeight);

    this.resetHeight();
  }


  resetHeight() {
    // reset the body height to that of the inner browser
    document.body.style.height = window.innerHeight + 'px';
    // let wrapper = document.getElementById('wrapper');
    // wrapper.style.height = window.innerHeight + 'px';
  }

}
